export default {
  home: "Home",
  services: "Services",
  support: "Support",
  about: "About us",
  login: "Log In",
  signup: "Sign Up",
  login_title: "Log In",
  login_subtitle: "Enter your details to access your account",
  login_method_label: "Login method",
  login_tab_mobile: "Mobile",
  login_tab_email: "Email",
  login_mobile_label: "Mobile number",
  login_mobile_placeholder: "05XXXXXXXX",
  login_email_label: "Email",
  login_email_placeholder: "name@example.com",
  login_password_label: "Password",
  login_password_placeholder: "••••••••",
  login_remember_me: "Remember me",
  login_forgot_password: "Forgot password?",
  login_submit: "Log In",
  login_loading: "Verifying...",
  login_no_account: "Don't have an account?",
  login_create_account: "Create one now",
  login_error_phone_required: "Please enter your mobile number.",
  login_error_email_required: "Please enter your email address.",
  login_error_phone_invalid: "Mobile number format is invalid.",
  login_error_email_invalid: "Email format is invalid.",
  login_error_password_required: "Please enter your password.",
  login_error_validation: "Please check the entered information.",
  login_error_invalid: "Login failed. Please check your credentials.",
  login_success: "Logged in successfully.",
  submitting: "Submitting...",
  last30_vs_prev30: "Last 30 / Prev 30",
  fp_title: "Reset Password",
  fp_subtitle: "Enter your email to receive a verification code to reset your password.",

  fp_email_label: "Email",
  fp_email_placeholder: "name@example.com",

  fp_send_code: "Send code",
  fp_sending: "Sending...",
  fp_continue: "Continue",
  fp_verifying: "Verifying...",
  fp_set_password: "Set new password",
  fp_saving: "Saving...",

  fp_resend: "Resend",
  fp_back_to_code: "Back to verification code",

  fp_remembered_password: "Remembered your password?",
  fp_back_to_login: "Back to login",

  fp_otp_label: "Enter verification code (6 digits)",
  fp_new_password: "New password",
  fp_confirm_password: "Confirm password",
  fp_password_placeholder: "••••••••",

  fp_err_email_required: "Please enter your email.",
  fp_err_email_invalid: "Invalid email format.",
  fp_err_otp_invalid: "Please enter a valid 6-digit code.",
  fp_err_password_required: "Please enter a new password.",
  fp_err_password_min: "Password must be at least 8 characters.",
  fp_err_confirm_required: "Please confirm your password.",
  fp_err_password_mismatch: "Passwords do not match.",

  fp_toast_code_sent: "Code sent successfully.",
  fp_toast_code_verified: "Code verified successfully.",
  fp_toast_password_set: "Password set successfully.",
  fp_toast_code_resent: "Code resent successfully.",
  // 🔐 Forgot Password – Resend / Timer
  fp_resend: "Resend code",
  fp_resend_in: "Resend in",
  fp_seconds: "s",
  fp_toast_code_resent: "Verification code resent successfully.",
  fp_toast_code_sent: "Verification code sent successfully.",
  fp_toast_code_verified: "Code verified successfully.",
  fp_toast_password_set: "Password updated successfully.",
  fp_cooldown_message: "Please wait before resending.",
  fp_err_otp_expired: "The verification code has expired. Please request a new one.",

  // Index page
  about_title: "Smart Consulting",
  slogan: "Your digital partner for sustainable growth — in line with",
  vision_2030: "Vision 2030",
  about_paragraph: `We believe every project deserves to grow with confidence and sustainability.
A smart platform that connects you with certified experts who deliver innovative, ready-to-implement solutions, guiding your success step by step toward a future aligned with Vision 2030.`,

  // About section headings
  about_tag: "Why Us?",
  about_subtitle:
    "Because we put your business needs at the heart of every consultation we provide",

  vision_title: "Vision",
  vision_text:
    "To be the digital compass for empowering entrepreneurs and SMEs through our integrated consulting solutions that lead the future and contribute to Saudi Arabia’s Vision 2030.",

  mission_title: "Mission",
  mission_text:
    "We are a comprehensive digital platform empowering entrepreneurs and SMEs. We offer integrated consulting solutions combining accredited expertise with innovative tools, analyzing challenges across management, finance, legal, and marketing to design tailored solutions that drive sustainable growth. We build long-term strategic partnerships and uphold the highest standards of quality and social responsibility, contributing to Vision 2030.",

  consulting: "Consulting",
  start_now: "Start now",
  contact_us: "Contact Us",
  stats_consulting: "Consultations",
  stats_active_consultants: "Active Consultants Rate",
  stats_clients: "Clients Rate",
  progress: "Progress",
  growth: "Growth",
  percent_sign: "%",
  stats_updating: "Updating stats...",
  retry: "Retry",
  svcs_empty: "No services available right now.",
  sidebar_item_home: "Home",

  svcs_tag: "Consulting Services",
  svcs_h: "Consulting Fields",
  svcs_p:
    "The Smart Consulting Platform offers more than just specialized consulting services that cover most of the needs of small and medium-sized enterprises, through a team of certified experts in seven key areas:",

  svcs_read_more: "Read More",

  // Services
  svc_hr_h: "Human Resources Management Consulting",
  svc_hr_p:
    "Building professional HR systems including org structures, policies, performance management, and compliance with the Saudi Labor Law.",

  svc_marketing_h: "Digital Marketing Consulting",
  svc_marketing_p:
    "Marketing identity development, digital marketing plans, ad campaign management, and market & competitor analysis.",

  svc_legal_h: "Commercial Legal Consultations",
  svc_legal_p:
    "Drafting and reviewing contracts, protecting intellectual property, legal compliance, and managing commercial disputes.",

  svc_gov_h: "Consultations on Dealing with Government Platforms",
  svc_gov_p:
    "Facilitating dealings with the Ministry of Commerce, Qiwa, Madad, Social Insurance, Absher, Muqeem, Balady, and all government platforms.",

  svc_design_h: "Design and Visual Identity Consulting",
  svc_design_p:
    "Logo design, full visual identity, UI/UX user interfaces, and official publications.",

  svc_finance_h: "Financial Consulting",
  svc_finance_p:
    "Financial planning, budgeting, cost analysis, and financial reporting in compliance with accounting standards.",

  svc_training_h: "Training and Development Consulting",
  svc_training_p:
    "Design training programs, assess skills gaps, and build training management systems.",

  svc_future_h: "Future Consulting",
  svc_future_p:
    "Providing innovative insights and forward-looking strategies to anticipate market shifts and ensure sustainable growth.",
  about_tag: "Why Us?",
  about_subtitle: "Mission and vision",

  vision_title: "Vision",
  vision_text:
    "To be the digital compass for empowering entrepreneurs and small and medium enterprises, through our integrated consulting solutions to lead the future and achieve the Kingdom’s Vision 2030.",

  mission_title: "Mission",
  mission_text:
    "We are a comprehensive digital platform empowering entrepreneurs and small and medium-sized enterprises (SMEs). We offer integrated consulting solutions that combine proven consulting expertise with innovative technical tools. We analyze challenges in management, finance, legal, and marketing to design customized solutions that drive sustainable growth. We believe that the success of our clients is the core of our success, and we harness our capabilities to build long-term strategic partnerships, while adhering to the highest standards of quality and social responsibility, thus contributing to the realization of the Kingdom's Vision 2030.",
  values_title: "Strategic Objectives",
  values_list: [
    "Empowering Saudi enterprises to achieve sustainable growth and excellence in their performance",
    "Leading growth and financial sustainability within the digital consulting sector",
    "Excellence in providing integrated and innovative digital solutions",
    "Leading the way in creating smart consulting solutions that meet the future of business",
  ],

  // Our Values (cards)
  values_cards_title: "Values",
  values_cards: [
    {
      title: "Digital Leadership",
      desc: "We pioneer digital innovation, guiding transformation with insight and vision.",
    },
    {
      title: "Sustainable Empowerment",
      desc: "We empower organizations to achieve lasting growth and impactful change.",
    },
    {
      title: "Strategic Partnership",
      desc: "We build enduring collaborations that foster mutual success and shared value.",
    },
    {
      title: "Authenticity and Quality",
      desc: "We commit to genuine excellence and uphold the highest quality standards.",
    },
  ],

  // Common copy (optional)
  values_tag: "Our Identity",
  values_h: "Our Values & Objectives",
  values_p:
    "We reflect our values in daily work and set clear objectives that drive us toward excellence.",

  contact_us: "Contact Us",
  // UNIQUE VALUE
  unique_h1: "Our",
  unique_h2: "Unique Value",
  unique_p:
    "The first platform that combines specialized consulting expertise and technical intelligence in a unified solution—delivering comprehensive, rapid consultations to SMEs with pricing that is not only reasonable, but truly flexible.",

  uv_tech: "Technical intelligence in a unified solution",
  uv_inclusive: "Inclusiveness",
  uv_price: "Price flexibility",
  uv_speed: "Speed",
  uv_expertise: "Specialized expertise",
  values_tag: "Our Identity",
  values_h: "Our Values & Goals",
  values_p:
    "We embody our values in everything we do and set clear objectives that drive our excellence.",
  values_tag: "Our Identity",
  values_h: "Our Values & Goals",
  values_p:
    "We reflect our values in our daily work and set clear objectives that drive our excellence.",

  // 1) Digital Leadership
  val_digital_lead_title: "Digital Leadership",
  val_digital_lead_desc:
    "Leading digital transformation with modern methods that boost competitiveness and innovation.",

  // 2) Sustainable Empowerment
  val_sustain_emp_title: "Sustainable Empowerment",
  val_sustain_emp_desc:
    "Empowering clients with long-term solutions that enhance sustainability and growth.",

  // 3) Strategic Partnership
  val_strat_part_title: "Strategic Partnership",
  val_strat_part_desc:
    "Building effective partnerships that deliver shared interests and lasting value.",

  // 4) Authenticity and Quality
  val_auth_quality_title: "Authenticity and Quality",
  val_auth_quality_desc:
    "Genuine practices and high-quality standards in everything we deliver.",

  values_list: [
    {
      title: "Digital Leadership",
      desc: "We pioneer digital innovation, guiding transformation with insight and vision.",
    },
    {
      title: "Sustainable Empowerment",
      desc: "We empower organizations to achieve lasting growth and impactful change.",
    },
    {
      title: "Strategic Partnership",
      desc: "We build enduring collaborations that foster mutual success and shared value.",
    },
    {
      title: "Authenticity and Quality",
      desc: "We commit to genuine excellence and uphold the highest quality standards.",
    },
  ],
  // Services
  svc_hr_h: "HR Consulting",
  svc_hr_h_full: "HR Consulting",
  svc_hr_desc:
    "Specialized consulting for SMEs to build HR systems aligned with best practices, support localization goals, and improve the employee experience.",
  svc_hr_pillars_title: "Key Areas",
  svc_hr_pillars: [
    "svc_hr_pt_1",
    "svc_hr_pt_2",
    "svc_hr_pt_3",
    "svc_hr_pt_4",
    "svc_hr_pt_5",
    "svc_hr_pt_6",
    "svc_hr_pt_7",
  ],
  svc_hr_pt_1: "Design org structures tailored to company size and activity",
  svc_hr_pt_2: "Build HR policies (leave, promotions, attendance, remote work)",
  svc_hr_pt_3: "Organize employee files and recruitment templates",
  svc_hr_pt_4: "Support performance management and rewards",
  svc_hr_pt_5: "Create career paths and internal development plans",
  svc_hr_pt_6: "Assist with Saudi labor law compliance and updates",
  svc_hr_pt_7: "Advise on hiring & termination in line with regulations",
  svc_hr_highlight_1:
    "Clear internal policies with up-to-date labor law compliance",
  svc_hr_highlight_2: "Improve performance efficiency and talent retention",
  svc_hr_highlight_3: "Enhance employee experience and organizational culture",
  svc_hr_cta_h: "Start building a solid HR foundation",
  svc_hr_cta_p: "Contact us and we’ll tailor a plan for your size and needs.",

  // ====== BRAND / GLOBAL ======
  admin_brand_title: "Welcome Ehsas",
  admin_brand_sub: "Ehsas Consulting",
  admin_search_placeholder: "Search in menu...",

  admin_logged_in_as: "Logged in as",
  admin_consulting_manager: "Consulting Manager",

  // ====== SIDEBAR GROUPS & ITEMS ======
  sidebar_brand: "Smart Consulting Platform",
  sidebar_group_account: "Account",
  sidebar_group_consultations: "Consultations",

  sidebar_item_account_settings: "Account Settings",
  sidebar_item_office_management: "Office Management",

  sidebar_item_create: "Create Consultation",
  sidebar_item_my_consultations: "My Consultations",
  sidebar_item_coming_session_consultations: " Session Consultations (Coming)",
  sidebar_item_coming_chat_consultations: "Coming Chat Consultations (Coming)",
  sidebar_item_profile: "Profile",
  sidebar_item_account_settings: "Account Settings",
  sidebar_item_all_consultations: "All Consultations",

  menu_profile: "Profile",
  menu_account_settings: "Account Settings",
  menu_logout: "Logout",

  // ====== ACCOUNT PAGE – HEADER & TABS ======
  account_settings_title: "Account Settings",
  account_settings_subtitle:
    "Update client information, address and bank details.",

  account_tab_account: "Account",
  account_tab_security: "Security",
  account_last_updated_hint: "Last updated a few moments ago",

  // ====== ACCOUNT – CLIENT SECTION ======
  account_section_client: "Client Information",

  account_field_client_name: "Client Name",
  account_field_client_name_placeholder: "Enter the client's full name",

  account_field_activity: "Business Activity",
  account_field_activity_placeholder: "Enter the main activity of the client",

  account_field_manager_name: "Manager Name",
  account_field_manager_name_placeholder:
    "Enter the responsible manager's name",

  // ====== ACCOUNT – ADDRESS SECTION ======
  account_section_address: "Address",

  account_field_city: "City",
  account_field_city_placeholder: "Enter city name",

  account_field_district: "District",
  account_field_district_placeholder: "Enter district / neighborhood",

  account_field_street: "Street",
  account_field_street_placeholder: "Enter street name",

  account_field_building_number: "Building Number",
  account_field_building_number_placeholder: "Enter building number",

  account_field_additional_number: "Additional Number",
  account_field_additional_number_placeholder:
    "Enter additional number (if any)",

  account_field_postal_code: "Postal Code",
  account_field_postal_code_placeholder: "Enter postal code",

  account_field_short_address: "Short Address",
  account_field_short_address_placeholder: "Short description of the address",

  // ====== ACCOUNT – BANK SECTION ======
  account_section_bank: "Bank Information",

  account_field_holder_name: "Account Holder Name",
  account_field_holder_name_placeholder: "Enter account holder name",

  account_field_iban: "IBAN / Account Number",
  account_field_iban_placeholder: "Enter IBAN or account number",

  account_field_bank_name: "Bank Name",
  account_field_bank_name_placeholder: "Enter bank name",

  // ====== ACCOUNT – ACTIONS ======
  account_btn_save: "Save Changes",
  account_btn_cancel: "Cancel",

  account_required_fields_note: "Fields marked with * are required.",

  // create consulting
  consult_create_title: "Create Consultation",
  consult_create_subtitle:
    "Fill in the details below to submit a new consultation request.",

  // Main fields
  consult_field_subject: "Subject",
  consult_field_subject_placeholder:
    "e.g. Relationship management in corporate banking services",

  consult_field_description: "Description",
  consult_field_description_placeholder:
    "Describe the details of the consultation you need...",

  consult_field_activity: "Activity",
  consult_field_activity_placeholder: "Select activity",
  consult_activity_corporate_banking: "Corporate banking services",
  consult_activity_sme: "SMEs",
  consult_activity_retail: "Retail / Individuals",

  consult_field_type: "Type",
  consult_field_type_placeholder: "Select consultation type",
  consult_type_general: "General consultation",
  consult_type_followup: "Follow-up",
  consult_type_urgent: "Urgent",

  // Attachments
  consult_section_attachments: "Attachments",
  consult_section_attachments_optional: "(optional)",
  consult_attachments_label: "Upload files related to this consultation",
  consult_office_label: "Upload files related to this office",
  consult_validation_subject_required: "Subject is required.",
  consult_validation_type_required: "Type is required.",
  consult_validation_date_required: "Appointment date is required.",
  consult_validation_time_required: "Appointment time is required.",
  consult_validation_url_required: "Session URL is required.",
  consult_attachments_hint: "You can upload PDFs, images (up to 2MB per file).",

  // Contact methods
  consult_section_contact_methods: "Contact Methods with the Consultant",

  consult_method_chat_title: "Instant Chat",
  consult_method_chat_desc:
    "Instant text chat with the consultant through the platform.",

  consult_method_video_title: "Video Call",
  consult_method_video_desc:
    "Live video session with the consultant with screen sharing.",

  consult_method_select: "Select This Method",
  consult_method_none_title: "No contact method",

  // Buttons / footer
  consult_btn_save_draft: "Save (Draft)",
  consult_btn_create: "Create",
  consult_btn_clear: "Clear",
  consult_required_note: "Fields marked with * are required.",
  consult_create_success: "Consultation created successfully.",
  consult_update_success: "Consultation updated successfully.",
  consult_saved_success: "Consultation saved successfully.",
  // Footer
  footer_brand: "Smart Consulting Platform",
  footer_brand_alt: "Smart Consulting Platform",
  footer_phone_label: "Customer Service",
  footer_whatsapp: "WhatsApp",
  footer_rights: "All rights reserved",
  footer_vision2030: "Vision 2030",

  // Page titles
  consult_my_title: "My Consultations",
  consult_my_subtitle:
    "View all your submitted consultations and their status.",

  consult_coming_session_title: "Upcoming session consultations",
  consult_coming_session_subtitle:
    "Session consultations scheduled ahead — filter and join when ready.",
  consult_coming_chat_title: "Upcoming chat consultations",
  consult_coming_chat_subtitle:
    "Chat consultations scheduled ahead — open the conversation when it's time.",
  consult_coming_back_my: "All my consultations",
  consult_coming_search_placeholder: "Subject or number…",
  consult_coming_search_hint: "Search by subject, consultation number, or contact.",
  consult_coming_filter_label: "Consultation filters",
  consult_coming_filter_all: "All",
  consult_coming_filter_today: "Today",
  consult_coming_filter_this_week: "This week",
  consult_coming_filter_under_study: "Under study",
  consult_coming_filter_active_hint: "Active filters",
  consult_coming_filter_clear_all: "Clear all",
  consult_coming_filter_status: "Quick filter",
  consult_coming_filter_search: "Search",
  consult_coming_filter_type: "Type",
  consult_coming_filter_payment: "Payment",
  consult_coming_filter_sort: "Sort",
  consult_coming_filter_more: "More filters",
  consult_coming_filter_appointment_from: "Appointment from",
  consult_coming_filter_appointment_to: "Appointment to",
  consult_coming_filter_appointment_range: "Appointment range",
  consult_coming_date_range_placeholder: "Select date range",
  consult_coming_date_range_apply: "Apply",
  consult_coming_date_range_clear: "Clear",
  consult_coming_filter_created_from: "Created from",
  consult_coming_filter_created_to: "Created to",
  consult_coming_table_appointment: "Appointment",
  consult_coming_empty: "No upcoming consultations yet.",
  consult_coming_empty_filtered: "No consultations match your filters.",
  consult_coming_empty_hint:
    "When you have scheduled consultations, they will appear here.",
  consult_coming_load_failed: "Couldn't load upcoming consultations.",
  consult_coming_sort_appointment_date: "Appointment date",
  consult_coming_sort_appointment_time: "Appointment time",
  consult_coming_sort_created_at: "Created date",
  consult_coming_sort_price: "Price",
  consult_coming_sort_number: "Consultation number",
  consult_coming_sort_status: "Status",
  consult_coming_order_asc: "Ascending",
  consult_coming_order_desc: "Descending",
  consult_filter_payment_all: "All payments",
  payment_status_cancelled: "Cancelled",
  payment_status_failed: "Failed",

  // Search & filters
  consult_my_search_placeholder: "Subject or description…",
  consult_my_search_hint: "Search by consultation subject or description.",
  consult_filter_status_all: "All statuses",
  consult_filter_activity_all: "All activities",

  // Status labels
  // Status labels
  consult_filter_type_all: "All types",
  consult_status_draft: "Draft",
  consult_status_open: "Under Study",
  consult_status_in_progress: "In Progress",
  consult_status_answered: "Finished",
  consult_status_closed: "Closed",
  consult_status_under_review: "Under Review",
  consult_status_new: "new",
  consult_status_finished: "finished",

  consult_filter_type_all: "All types",
  consult_status_draft: "Draft",
  consult_status_open: "Under Study",
  consult_status_in_progress: "In Progress",
  consult_status_answered: "Finished",
  consult_status_closed: "Closed",
  consult_status_under_review: "Under Review",
  consult_status_new: "new",
  consult_status_finished: "finished",

  // Activities
  consult_activity_unknown: "Other activity",
  consult_activity_corporate_banking: "Corporate Banking",
  consult_activity_sme: "SME",
  consult_activity_retail: "Retail Banking",

  // Types
  consult_type_general: "General",
  consult_type_followup: "Follow-up",
  consult_type_urgent: "Urgent",

  // Empty state
  consult_my_empty_title: "No consultations yet",
  consult_my_empty_subtitle: "You haven’t submitted any consultations so far.",
  consult_my_empty_cta: "Create a new consultation",
  consult_my_empty_filtered: "No consultations match your filters.",
  consult_filter_label: "Filter by status",
  consult_filter_all: "All",
  consult_filter_clear: "Clear filter",
  consult_filter_clear_all: "Clear all",
  consult_filter_status: "Status",
  consult_filter_search: "Search",
  consult_filter_type: "Type",
  consult_filter_type_search: "Search categories...",
  consult_filter_type_empty: "No categories found",
  consult_filter_active_hint: "Filtered results",

  // Table headers
  consult_table_number: "Consultation Number",
  consult_table_subject: "Subject",
  consult_table_date: "Date",
  consult_table_activity: "Activity",
  consult_table_type: "Type",
  consult_table_method: "Method",
  consult_table_created_at: "Created At",

  consult_table_status: "Status",
  consult_table_actions: "Actions",

  // Table helpers
  consult_table_no_desc: "No description provided",
  consult_table_showing: "Showing",
  consult_table_of: "of",
  consult_table_entries: "entries",
  consult_table_prev: "Previous",
  consult_table_next: "Next",
  consult_table_page: "Page",

  // Methods
  consult_method_session_title: "Session",
  consult_method_chat_title: "Chat",
  consult_method_video_title: "Video call",
  consult_method_link: "Link",

  // Actions (dropdown)
  consult_action_view: "View details",
  consult_copy_number: "Copy consultation number",
  consult_action_edit: "Edit consultation",
  consult_action_cancel: "Cancel consultation",
  office_settings_title: "Account Settings",
  office_settings_subtitle: " Update consultant office information, address and bank details.",
  consultant_field_name: "Name",
  consultant_field_license_number: "License Number",
  consultant_field_image: 'Profile Image',
  office_title: "Office Information",
  office_subtitle:
    "Manage your office registration details and official documents.",
  consultant_field_specialization: 'Specialization',
  consultant_field_qualification: 'Qualification',
  consultant_section_profile: 'Consultant Info',
  office_section_info: "Office Information",
  office_section_upload: "Upload Files",

  office_optional: "(optional)",

  office_field_crn: "Commercial Registration No.",
  office_field_crn_placeholder: "Enter commercial registration number",

  office_field_establishment: "Establishment No.",
  office_field_establishment_placeholder: "Enter establishment number",

  office_field_unified_no: "Unified No.",
  office_field_unified_no_placeholder: "Enter unified number",

  office_field_tax_no: "Tax No.",
  office_field_tax_no_placeholder: "Enter tax number",

  office_field_insurance_no: "Insurance No.",
  office_field_insurance_no_placeholder: "Enter insurance number",

  office_existing_files_title: "Existing Files",
  office_existing_logo: "Current Logo",
  office_existing_letterhead: "Current Letterhead",
  office_existing_unified: "Current Unified Number Doc",
  office_existing_establishment: "Current Establishment Doc",
  office_existing_registration: "Current Registration Doc",

  office_upload_logo: "Logo (optional)",
  office_upload_logo_placeholder: "Choose logo file",

  office_upload_letterhead: "Letterhead (optional)",
  office_upload_letterhead_placeholder: "Choose letterhead file",

  office_upload_unified: "Unified Number Doc (optional)",
  office_upload_unified_placeholder: "Choose unified number document",

  office_upload_establishment: "Establishment Doc (optional)",
  office_upload_establishment_placeholder: "Choose establishment document",

  office_upload_registration: "Registration Doc (optional)",
  office_upload_registration_placeholder: "Choose registration document",

  office_btn_save: "Save Office Info",
  office_btn_reload: "Reload",
  office_note_optional:
    "All fields are optional. Fill in what you have available.",

  office_choose_doc_type: "Choose document type",
  office_upload_hint:
    "Select a file for the chosen file type. You can upload either image or pdf up to 2M one file per type.",
  office_saved_success: "Office information saved successfully ",

  consult_chat_date: "Appointment Date",
  consult_chat_time: "Time",

  consult_video_date: "Appointment Date",
  consult_video_time: "Time",
  consult_video_url: "Session URL",
  consult_video_url_placeholder: "Zoom / Teams / Meet link",

  // UserProfile
  profile_title: "Profile",
  profile_subtitle: "Update your personal information and account settings.",
  status_inactive: "Inactive",
  status_active: "Active",

  section_about_client: "About Client",
  section_user: "User",
  section_address: "Address",
  section_bank: "Bank Overview",
  section_office: "Office",
  section_documents: "Documents",

  field_client: "Client",
  field_manager: "Manager",
  field_client_type: "Client Type",
  choose_client_type: "Choose Client Type",
  choose: "choose",
  field_activity: "Activity",

  field_user_name: "User Name",
  field_email: "Email",
  field_phone: "Phone",
  field_status: "Status",
  field_role: "Role",

  field_city: "City",
  field_district: "District",
  field_street: "Street",
  field_building_no: "Building No.",
  field_additional_no: "Additional No.",
  field_postal_code: "Postal Code",
  field_short_address: "Short Address",

  field_account_holder: "Account Holder",
  field_account_no: "Account No.",
  field_bank_name: "Bank",

  field_commercial_reg: "Commercial Reg. No.",
  field_establishment_no: "Establishment No.",
  field_unified_no: "Unified No.",
  field_tax_no: "Tax No.",
  field_insurance_no: "Insurance No.",

  // Security tab
  security_section_title: "Security and Password Change",

  security_current_password: "Current Password",
  security_current_password_placeholder: "Enter current password",

  security_new_password: "New Password",
  security_new_password_placeholder: "Enter new password",

  security_confirm_password: "Confirm New Password",
  security_confirm_password_placeholder: "Re-enter new password",

  security_password_requirements_title: "Password Requirements",
  security_password_req_len: "Minimum 8 characters (the more, the better)",
  security_password_req_lower: "At least one lowercase letter (a-z)",
  security_password_req_number_symbol: "At least one number, symbol, or space",

  security_btn_save: "Save Password",
  security_btn_saving: "Saving...",
  security_btn_reset: "Reset",

  security_password_hint: "Use a strong and previously unused password.",
  security_password_success: "Password updated successfully.",
  security_password_failed:
    "Failed to update password, please check the information.",

  // toast
  account_btn_saving: "Saving...",
  account_saved_success: "Saved successfully ",
  account_saved_failed: "Save failed, please try again",

  cookie_err_auth_user_missing:
    "Your session data is missing. Please sign in again.",
  cookie_err_auth_user_parse_failed:
    "Could not read your session data. Please sign in again.",
  cookie_err_auth_token_missing:
    "Your session has expired. Please sign in again.",
  cookie_err_client_id_not_found:
    "Client ID was not found in your session. Please sign in again.",
  cookie_err_consultant_id_not_found:
    "Consultant ID was not found in your session. Please sign in again.",
  cookie_err_office_id_not_found:
    "Office ID was not found in your session. Please sign in again.",
  cookie_err_user_data_not_found:
    "No user data was found in your session. Please sign in again.",

  consult_method_session: "Session method selected",
  consult_method_chat: "Chat method selected",
  consult_type_hr: "Human Resources",
  consult_type_marketing: "Marketing",
  consult_type_government: "Government platforms",

  // ===== Common =====
  back: "Back",
  edit: "Edit",
  save: "Save",
  publish: "Publish",
  saving: "Saving...",
  loading: "Loading...",

  // ===== Office Details =====
  office_details_title: "Office Details",
  office_details_subtitle: "View office information and documents",
  office_info: "Office Info",
  office_documents: "Documents",
  office_no_docs: "No documents uploaded.",

  office_field_id: "ID",
  office_field_owner_id: "Owner ID",
  office_field_crn: "Commercial Registration Number",
  office_field_establishment: "Establishment Number",
  office_field_unified_no: "Unified Number",
  office_field_tax_no: "Tax Number",
  office_field_insurance_no: "Insurance Number",

  office_existing_logo: "Logo",
  office_existing_letterhead: "Letterhead",
  office_existing_unified: "Unified Doc",
  office_existing_establishment: "Establishment Doc",
  office_existing_registration: "Registration Doc",

  // ===== Consultation Edit =====
  consult_edit_title: "Edit Consultation",
  consult_edit_subtitle: "Update consultation details",

  consultation_status: "CONSULTATION STATUS",
  consultation_info: "CONSULTATION INFO",

  consult_table_number: "#",
  consult_table_date: "Date",
  consult_table_activity: "Activity",
  consult_table_type: "Type",
  consult_table_subject: "Subject",

  offer_price: "OFFER PRICE",
  offer_details: "Offer Details",
  offer_provider_info: "Offer Provider Info",
  offer_details: "Offer Details",
  offer_provider_info: "Offer Provider Info",
  offer_details: "Offer Details",
  offer_provider_info: "Offer Provider Info",
  offer_details: "Offer Details",
  offer_provider_info: "Offer Provider Info",
  offer_details: "Offer Details",
  offer_provider_info: "Offer Provider Info",
  offer_details: "Offer Details",
  offer_provider_info: "Offer Provider Info",
  offer_before_tax: "Before tax",
  tax_percent: "Tax %",
  total_amount: "Total",
  update_offer: "Update Offer",

  contact_method: "CONTACT METHOD",
  method: "Method",
  date: "Date",
  time: "Time",
  session_link: "Session link",
  chat_link: "Chat link",

  priority: "Priority",
  normal: "Normal",
  urgent: "Urgent",
  description: "Description",

  attachments: "Attachments",
  add_attachment: "Add",
  no_attachments: "No attachments yet.",
  view: "View",
  delete: "Delete",

  consultant_response: "Consultant Response",
  consultant_response_placeholder: "Write your response...",
  save_response: "Save Response",

  // Status options
  consult_status_under_study: "Under study",
  consult_status_open: "Open",
  consult_status_in_progress: "In progress",
  consult_status_answered: "Answered",
  consult_status_closed: "Closed",

  // Activity options
  consult_activity_corporate_banking: "Corporate banking",
  consult_activity_sme: "SME",
  consult_activity_retail: "Retail",

  consult_method_chat: "Chat",
  consult_method_session: "Session",
  consult_details_title: "Consultation Details",
  consult_details_subtitle: "View consultation info",

  back: "Back",
  accept: "Accept",
  reject: "Reject",

  consultation_status: "Consultation Status",
  status: "Status",

  consult_status_under_study: "Under study",
  consult_status_open: "Open",
  consult_status_in_progress: "In progress",
  consult_status_answered: "Answered",
  consult_status_closed: "Closed",
  consult_status_accepted: "Accepted",
  consult_status_rejected: "Rejected",

  consultation_info: "Consultation Info",
  consult_table_number: "Number",
  consult_table_date: "Date",
  consult_table_activity: "Activity",
  consult_table_type: "Type",

  offer_price: "Offer Price",
  offer_details: "Offer Details",
  offer_provider_info: "Offer Provider Info",
  offer_before_tax: "Before tax",
  tax_percent: "Tax %",
  total_amount: "Total",

  contact_method: "Contact Method",
  method: "Method",
  date: "Date",
  time: "Time",
  session_link: "Session link",
  consult_method_chat: "Chat",
  consult_method_session: "Session",

  consult_table_subject: "Subject",
  priority: "Priority",
  normal: "Normal",
  urgent: "Urgent",
  description: "Description",

  attachments: "Attachments",
  no_attachments: "No attachments yet.",
  view: "View",

  consultant_response: "Consultant Response",
  no_response: "No response yet.",

  processing: "Processing...",
  loading: "Loading...",

  // contact us
  contact_company_name: "Company Name",
  contact_company_name_ph: " Enter your company name",
  contact_title: "Contact Us",
  contact_subtitle:
    "We’re here to help. Send your message and we’ll get back to you soon.",
  contact_support_title: "Support & Inquiries",
  contact_support_desc: "Reach us anytime by phone or email.",
  contact_office_title: "Our Office",
  contact_office_desc: "Visit us or contact us online.",
  contact_office_address: "Riyadh, Saudi Arabia — (put real address here)",
  contact_map_placeholder: "Location Map",
  contact_social_title: "Follow Us",

  contact_form_title: "Send a Message",
  contact_form_desc: "Fill the form and we’ll contact you shortly.",

  contact_name: "Full Name",
  contact_email: "Email",
  contact_phone: "Phone",
  contact_subject: "Subject",
  contact_service: "Service Type",
  contact_message: "Message",

  contact_name_ph: "Write your name",
  contact_email_ph: "example@email.com",
  contact_phone_ph: "+966...",
  contact_subject_ph: "Message subject",
  contact_service_all: "Choose a service",
  contact_message_ph: "Write your request details here...",
  contact_send: "Send",
  contact_sent: "Your message has been sent ",

  // sidebar
  user_type: "User type",
  selected: "Selected",
  requirements_and_approval: "Requirements & approval",
  valid_data: "Valid data",
  valid_data_hint: "Make sure it matches the commercial register.",
  active_mobile: "Active mobile number",
  active_mobile_hint: "You will receive a verification code via SMS.",
  official_email: "Official email",
  official_email_hint: "For contracts and invoices notifications.",
  progress: "Progress",

  // stepper
  step: "Step",
  of: "of",

  // select hints
  choose_client_type_hint: "Choose the suitable client type",
  choose_consultant_type_hint: "Choose the suitable consultant type",

  // labels step 1
  client_type: "Client type",
  client_location: "Client location",
  consultant_type: "Consultant type",
  org_name: "Organization name",
  org_name_ph: "e.g. Smart Consulting Platform",
  activity: "Activity",
  activity_ph: "e.g. Business consulting",
  simple_description: "Short description",
  simple_description_hint:
    "Write a brief description of your organization or service",
  simple_description_ph: "Write a short description...",
  manager_name: "Manager name",
  manager_name_ph: "e.g. Ahmed Al-Otaibi",
  mobile: "Mobile number",
  mobile_ph: "05XXXXXXXX",
  official_email_label: "Official email",
  official_email_ph: "name@company.sa",

  // step 2
  region: "Region",
  city: "City",
  district: "District",
  street: "Street",
  building_no: "Building No.",
  zip: "Postal code",
  extra_no: "Extra number",
  short_address: "Short address",
  address_region_ph: "e.g., Riyadh Region",
  address_city_ph: "e.g., Riyadh",
  address_district_ph: "e.g., Al Olaya",
  address_street_ph: "e.g., King Fahd Rd",
  address_building_number_ph: "e.g., 1234",
  address_additional_number_ph: "e.g., 5678",
  address_postal_code_ph: "e.g., 12345",
  address_short_address_ph: "e.g., 1234 King Fahd Rd, Riyadh",
  office_address_city_ph: "e.g., Riyadh",
  office_address_district_ph: "e.g., Al Olaya",
  office_address_street_ph: "e.g., King Fahd Rd",
  office_address_building_number_ph: "e.g., 1234",
  office_address_additional_number_ph: "e.g., 5678",
  office_address_postal_code_ph: "e.g., 12345",
  office_address_short_address_ph: "e.g., 1234 King Fahd Rd, Riyadh",

  // step 3
  bank_owner: "Account holder name",
  bank_name: "Bank name",
  bank_account: "Bank account number",
  iban: "IBAN",
  iban_ph: "SAxx xxxx xxxx xxxx xxxx xxxx",
  tax_no: "Tax number",

  // step 4
  cr_no: "Commercial register number",
  org_no: "Organization number",
  unified_no: "Unified number",
  logo_attach: "Logo attachment",
  letterhead_attach: "Letterhead attachment",

  declarations: "Declarations",
  accept_data_text:
    "I declare that all information provided during registration is true and complete and belongs to me personally, and I take full legal responsibility for any false or forged data.",
  accept_terms_text:
    "I declare that I have read and accepted all terms and conditions governing the platform, and this acceptance is legally binding without future objection.",

  // buttons
  prev: "Previous",
  next: "Next",
  save: "Save",

  // otp
  verify_account: "Account verification",
  otp_sent_to: "A 6-digit verification code was sent to",
  verify_wrong_email: "Wrong email?",
  verify_back_to_register: "Register again",
  verify_back_to_login: "Back to login",
  verify_session_expired: "Your verification session expired. Please register again.",
  verify_session_expired_login: "Your verification session expired. Please log in again.",
  verify_code_expires_in: "Code expires in",
  verify_code_expired: "Verification code expired. Resend a new code.",
  confirm: "Confirm",
  resend: "Resend",
  verified_success: "Verified successfully ",
  deleted_success: "Deleted successfully ",

  // ===== Missing keys used by the component =====
  step_customer: "Client Information",
  step_address: "National Address",
  step_bank: "Bank Details",
  step_org: "Organization Details",

  type_client: "Client",
  type_consultant: "Consultant",
  type_office: "Consulting Office",

  opt_entrepreneur: "Entrepreneurs",
  opt_nascent: "Startup",
  opt_small_business: "Small Business",

  opt_individual: "Individual",
  opt_consulting_office: "Consulting Office",

  otp_invalid: "Invalid code, please try again.",
  verified_alert: "Verified successfully ",

  // steps titles used in edited page
  step_consultant_info: "Consultant Information",
  consultant_info: "Consultant Information",
  consultant_info_hint: "Professional details used to set up your consultant profile.",
  step_consultant_profile: "Consultant Details",

  // step 1 labels + placeholders
  consultant_name_label: "Name",
  consultant_name_ph: "Example: Smart Consulting Experts Office",

  consultant_license_label: "License Number",
  consultant_license_ph: "Example: 123456",

  consultant_person_label: "Consultant Name",
  consultant_person_ph: "Example: Ahmed Al-Otaibi",

  // password field
  password: "Password",
  password_ph: "••••••••",

  // step 4 (qualifications)
  degree: "Academic Qualification",
  degree_ph: "Example: MBA",

  specialization: "Specialization",
  specialization_ph: "Example: Project Management",

  certificate_attach: "Certificate Attachment",

  documents_attach: "Document Attachments",
  attach: "Attachment",
  attach_title: "Title",
  attach_title_ph: "Write an attachment title",

  add_attach: "Add Attachment",
  org_name_ph_office: "Example: Advanced Consulting Office",
  activity_ph_business: "Example: Business Consulting",
  official_email_ph_office: "name@office.sa",

  cr_attachment_label: "CR Attachment",
  org_attachment_label: "Attachment",
  unified_attachment_label: "Attachment",
  tax_no_ph: "Example: 300123456700003",

  license_no_label: "License Number",
  license_no_ph: "Example: 1234567890",
  cr_no_ph: "Example: 1010123456",
  step_establishment_info: "Establishment Information",
  step_consulting_office_info: "Consulting Office Information",
  password_confirm: "Confirm Password",
  password_confirm_ph: "••••••••",
  user_name: "Username",
  user_name_ph: "Example: user123",

  office_change: "Change",
  office_remove: "Remove",
  office_no_file: "No file",

  office_selected_uploads: "Selected uploads",
  office_fetch_failed: "Failed to load office info",
  office_saved_failed: "Failed to save office info. Please try again.",

  office_upload_placeholder_logo: "Choose logo file",
  office_upload_placeholder_letterhead: "Choose letterhead file",
  office_upload_placeholder_unified_doc: "Choose unified number document",
  office_upload_placeholder_establishment_doc: "Choose establishment document",
  office_upload_placeholder_registration_doc:
    "Choose commercial registration document",

  section_about_consultant: "About Consultant",
  field_consultant_name: "Consultant Name",
  field_license_number: "License Number",
  field_type: "Type",
  field_specialization: "Specialization",
  field_qualification: "Qualification",
  role_consultant: "Consultant",
  role_client: "Client",
  role_consultant_office: "Consultant Office",

  account_field_qualification: "Qualification",
  account_field_attachments: "Add New Attachments",
  account_field_qualification_placeholder: "Enter your qualification",
  account_field_attachments_hint:
    "Existing files are shown above (grey). Newly selected files appear in blue.",
  account_field_attachments_placeholder: "Choose files to upload",

  accept_data_required: "Please confirm that the provided data is correct.",
  accept_terms_required: "Please accept the terms and conditions.",
  account_field_activity_description: "Activity Description",
  contact_error_validation: "Make Validate Required Inputs",
  contact_error_generic: "Error",
  attachments_hint: "Files shared by the client with the request.",
  offer_hint: "Includes the consultation fee and tax.",
  client_info: "Client Information",
  client_info_hint: "Request owner details.",
  client_name: "Name",
  client_company: "Company",
  client_email: "Email",
  client_phone: "Phone",
  contact_method_hint: "How the consultation will be held.",
  consultant_response_hint:
    "Your written advice or notes for the client will appear here.",
  view_response_hint: "View the consultant response.",
  write_response: "Write response",
  consult_all_title: "All Consultations",
  consult_all_subtitle: "View and manage all consultations in the system",
  consult_all_search_placeholder:
    "Search by number, subject, or description...",
  consult_filter_owner_all: "All users",
  consult_offer_hint:
    "Set your offer price and session details, then send it to the client.",
  send_offer: "Send Offer",
  offer_sent_success: "Offer Send Successfully",
  accepted_success: "The request has been accepted successfully",
  rejected_success: "The request has been rejected successfully",
  write_your_response: "Write Response",
  response_sent_success: "Response sent successfully.",
  consult_method_none_desc: "I don't need to be contacted right now.",
  files_selected: "files selected",
  click_to_change_files: "Click to change files",
  Construction: "Construction",

  chat_title: "Chat",
  consultation_chat_subtitle: "Conversation related to this consultation",
  payment_required_chat: "Payment required to access chat.",
  negotiate: "Negotiate",
  view_negotiation: "View Negotiation",
  negotiation_title: "Negotiation",
  negotiation_subtitle: "Negotiate consultation terms",
  negotiation_window_title: "Financial Negotiation Window",
  current_offer: "Current Offer",
  negotiate_offer: "Edit / Offer",
  accept_price: "Accept Price",
  negotiation_your_offer: "Your offer",
  negotiation_form_hint: "Price and note are sent together",
  negotiation_your_turn: "It's your turn — send your offer to continue.",
  negotiation_make_offer: "Make an offer",
  negotiation_counter_offer: "Send counter-offer",
  negotiation_offer_modal_subtitle:
    "Enter the amount and an optional note; both are sent together.",
  negotiation_latest_other_offer: "Latest offer from the other party",
  negotiation_last_price: "Last offered price",
  negotiation_history: "Financial negotiation log",
  negotiation_round_of: "Round",
  negotiation_limit_note:
    "Your opening price counts as attempt 1 of 3 available to you as the consultant. After that you cannot submit any other offer.",
  negotiation_limit_modal_note:
    "Reminder: your opening price is attempt 1 of 3 for you as the consultant. It does not count against the client.",
  negotiation_limit_note_client:
    "You can send 3 negotiation offers only. After that you cannot submit any other offer.",
  negotiation_limit_modal_note_client:
    "Reminder: you have 3 negotiation attempts only.",
  negotiation_client_turn: "Client's turn",
  negotiation_consultant_turn: "Consultant's turn",
  negotiation_final_round_warning_consultant:
    "This is your last allowed round — after this you must accept or reject, and no further offers can be submitted.",
  negotiation_final_round_warning_client:
    "This is your last allowed round — no further offers can be submitted.",
  negotiation_last_offer: "Send final offer",
  negotiation_max_offers_hint:
    "Maximum offers reached. Please accept or reject the latest offer.",
  negotiation_accept_hint: "Accept the latest offer from the other party",
  negotiation_accept_no_note: "No conditions note attached to this offer.",
  negotiation_note_label: "Note / details",
  optional: "optional",
  negotiation_empty: "No negotiations yet.",
  negotiation_load_failed: "Failed to load negotiations.",
  negotiation_offer_failed: "Failed to submit offer.",
  negotiation_accept_failed: "Failed to accept price.",
  negotiation_offer_success: "Offer submitted successfully.",
  negotiation_accept_success: "Price accepted successfully.",
  negotiation_reject_consultation: "Reject consultation",
  negotiation_reject_hint:
    "If the offer does not suit you, you can reject the consultation.",
  negotiation_reject_confirm:
    "Are you sure you want to reject this consultation? The negotiation will be closed and cannot be reopened.",
  negotiation_reject_success: "The consultation has been rejected.",
  negotiation_reject_failed: "Failed to reject the consultation.",
  negotiation_rejected: "The consultation was rejected. Negotiation is closed.",
  negotiation_agreed: "An offer has been agreed. Negotiation is closed.",
  negotiation_closed: "Negotiation closed",
  negotiation_agreed_on: "An offer has been agreed",
  negotiation_waiting_other:
    "Your offer was sent. Waiting for the other party to respond.",
  negotiation_price_sent: "Amount sent (with tax)",
  negotiation_tax_added_hint:
    "Tax will be added and the total will be sent to the client.",
  negotiation_amount_required: "Please enter a valid amount.",
  negotiation_amount_placeholder: "Amount",
  negotiation_note_placeholder: "Note / consultation details (optional)",
  currency_sar: "SAR",
  back: "Back",
  conversation: "Conversation",
  loading: "Loading...",
  no_messages: "No messages yet.",
  you: "You",
  other: "Other party",
  type_message: "Type a message...",
  chat_load_failed: "Failed to load the conversation.",
  chat_send_failed: "Failed to send the message.",
  consult_open_chat: "Open chat",
  consult_method_link: "Link",

  required: "This field is required",
  validation_required: "This field is required",
  validation_invalid: "Invalid value",
  validation_url: "Invalid URL",
  validation_date: "Invalid date",
  validation_time: "Invalid time",
  please_fix_errors: "Please fix the highlighted errors",
  enter_to_send_hint: "اضغط Enter للإرسال • Shift + Enter لسطر جديد",

  payment_method: "Payment Method",
  payment_method_hint: "Choose how you want to pay.",
  bank_transfer: "Bank Transfer",
  cash: "Cash",
  choose_account: "Choose account",
  no_bank_accounts: "No bank accounts found",
  save_payment: "Save Payment",
  loading: "Loading...",
  processing: "Processing...",
  payment_saved: "Payment saved successfully",
  payment_error: "Failed to save payment",
  choose_payment_data: "Please select payment data",
  bank_account: "Bank Account",
  open_invoices: "Open Invoices",

  invoice: "Invoice",
  payment_details: "Payment details",
  consult_table_number: "Number",
  consult_table_date: "Date",
  offer_before_tax: "Before tax",
  tax_percent: "Tax percent",
  tax_amount: "Tax amount",
  total_amount: "Total",
  payment_method: "Payment method",
  bank_transfer: "Bank transfer",
  pending: "Pending",
  account_number: "Account number",
  confirm_and_accept: "Confirm & Accept",
  close: "Close",
  remove: "Remove",

  account_identifier: "Account identifier",
  transaction_reference: "Transaction reference",
  payment_image: "Payment image",

  upload_image: "Upload image",
  upload_image_hint: "PNG, JPG up to 2MB",
  choose_file: "Choose file",
  change_file: "Change file",
  max_file_size: "Max 1MB",

  account_identifier_required: "Account identifier is required",
  account_identifier_invalid: "Account identifier must be numbers only",
  transaction_reference_required: "Transaction reference is required",
  payment_image_required: "Payment image is required",
  please_check_required_fields: "Please check the required fields",
  transaction_reference_invalid: "Invalid transaction reference",
  choose_account_required: "Please choose a bank account",
  invalid_file_type: "Invalid file type",
  file_too_large: "File is too large",
  invoice_not_found: "Invoice not found for this consultation.",
  payment_saved_success: "Payment saved successfully ",

  sidebar_item_my_invoices: "My Invoices",
  my_invoices: "My Invoices",
  my_invoices_hint: "Track your invoices and payment status.",
  no_invoices: "No invoices found.",
  search_by_invoice_or_consultation: "Search by invoice # or consultation #",
  view_payment_image: "View payment image",
  search: "search...",
  invoices: "Invoices",
  paid: "Paid",
  all: "All",
  refresh: "Refresh",
  pay: " Pay",
  consult_table_owner: "The User",
  selected_file: "Selected file",
  accept_confirm_text:
    "Are you sure you want to accept this consultation? After accepting, you will be able to proceed with the next steps.",
  confirm_accept: "Confirm Accept",
  account_identifier_placeholder: "Enter account number or identifier",
  transaction_reference_placeholder:
    "Enter transaction reference (e.g. SA0380...)",

  org_name_required: "Organization name is required",
  office_name_required: "Office name is required",
  activity_required: "Activity is required",
  manager_required: "Manager name is required",
  user_name_required: "User name is required",
  client_type_required: "Client type is required",
  email_required: "Email is required",
  invalid_email: "Invalid email address",
  phone_required: "Phone is required",
  invalid_phone: "Invalid phone number",
  simple_description_required: "Short description is required",
  password_required: "Password is required",
  password_min_8: "Password must be at least 8 characters",
  password_confirm_required: "Password confirmation is required",
  password_not_match: "Passwords do not match",

  city_required: "City is required",
  district_required: "District is required",
  street_required: "Street is required",
  building_no_required: "Building number is required",
  extra_no_required: "Additional number is required",
  zip_required: "Postal code is required",
  short_address_required: "Short address is required",

  bank_owner_required: "Account holder name is required",
  bank_account_required: "Account number is required",
  bank_name_required: "Bank name is required",

  consultant_name_required: "Consultant name is required",
  license_required: "License number is required",
  consultant_person_required: "Consultant person name is required",
  region_required: "Region is required",
  tax_no_required: "Tax number is required",
  degree_required: "Academic degree is required",
  specialization_required: "Specialization is required",
  license_already_used: "License number is already in use.",

  certificate_required: "Certificate is required",
  attachments_required: "Please attach at least one file",
  attach_title_required: "Attachment title is required",
  accept_data_required: "Please accept data policy",
  accept_terms_required: "Please accept terms and conditions",
  please_check_required: "Please check required fields.",
  register_success: "Registration completed successfully.",

  rejected: "Rejected",
  consultation_rejected_msg: "The consultation has been rejected",
  reject_popup_hint: "Are you sure you want to reject this consultation?",
  confirm_reject: "Confirm rejection",

  payment_status: "Payment status",
  payment_status_paid: "Paid",
  payment_status_under_review: "Under review",
  payment_status_unpaid: "Unpaid",
  payment_status_rejected: "Rejected",
  payment_status_pending: "Pending payment",
  payment_status_not_required: "Not required yet",
  payment_status_unknown: "Unknown",

  consultant_settings_title: "Consultant Settings",
  consultant_settings_subtitle: "Update your consultant profile.",

  choose_files: "Choose files",
  no_file_chosen: "No file chosen",

  consultant_section_more: "More Information",
  consultant_field_type: "Consultant Type",
  consultant_field_current_logo: "Current Logo",
  consultant_section_address: "Address",

  address_city: "City",
  address_district: "District",
  address_street: "Street",
  address_building: "Building Number",
  address_additional: "Additional Number",
  address_postal: "Postal Code",
  address_short: "Short Address",

  consultant_section_bank: "Bank Account",
  bank_holder: "Account Holder",
  bank_iban: "IBAN / Account Number",

  consultant_section_attachments: "Attachments",
  consultant_existing_attachments: "Existing Attachments",
  consultant_new_attachments: "Add New Attachments",

  file_hint_image: "PNG, JPG up to ~5MB",
  file_hint_attachments: "Images or PDF",

  office_name: "Office Name",
  office_name_ph: "Enter office name",
  Dashboard: "Dashboard",
  payment_under_review_title: "Payment Under Review",
  payment_under_review_desc:
    "Your payment is currently under review. Once it is approved, the consultant response will appear here.",
  filters: "Filters",
  apply: "Apply",
  consult_status_new: "New",
  consult_status_finished: "Finished",
  reset: "Reset",
  // ==== GENERAL / LAYOUT ====
  register_title_client: "Register a new account",
  register_subtitle_fast:
    "Choose the account type and complete the guided steps.",
  register_badge: "New registration",
  register_secure: "Secure process",
  register_fast_hint: "A simple, guided registration with clear steps.",
  selected: "Selected type",
  register_note_verify:
    "Your account may require verification before activation.",

  // ==== USER TYPE (TOP SELECTOR) ====
  user_type: "User type",
  user_type_title: "Choose account type",
  user_type_hint:
    "Pick the option that best matches you. The form will adapt automatically.",

  type_client: "Client",
  type_consultant: "Consultant",
  type_office: "Office",

  type_client_desc:
    "Organizations or individuals looking for consulting services.",
  type_consultant_desc:
    "Independent experts providing consulting and advisory services.",
  type_office_desc: "Consulting offices or firms with a full team.",

  // ==== STEPPER ====
  step_client_info: "Client information",
  step_account_info: "Account information",
  office_info: "Office Information",
  office_info_hint: "Office details used to set up your consulting office profile.",
  account_info: "Account Information",
  account_info_hint: "Login details and contact information for this account.",
  step_declarations: "Declarations",

  prev: "Previous",
  next: "Next",

  // ==== CLIENT SECTION ====
  client_section: "Client details",
  client_section_hint: "Tell us about your organization or project.",

  org_name: "Organization name",
  org_name_ph: "Enter organization name",
  manager_name: "Responsible person / manager",
  manager_name_ph: "Enter manager name",
  activity: "Main activity",
  activity_ph: "Briefly describe the main activity",
  client_type: "Client type",
  choose_client_type_hint: "Choose the category that best fits your case.",
  simple_description: "Simple description",
  simple_description_hint: " a short description of your activity.",
  simple_description_ph: "Write a brief description of your activity",

  // ==== USER SECTION ====
  user_section: "User details",
  user_section_hint: "Your personal login information.",

  user_name: "User name",
  user_name_ph: "Enter your full name",
  official_email_label: "Official email",
  official_email_ph: "name@example.com",
  mobile: "Mobile number",
  mobile_ph: "05xxxxxxxx",
  password: "Password",
  password_ph: "Enter a strong password",
  password_confirm: "Confirm password",
  password_confirm_ph: "Re-enter your password",

  // ==== DECLARATIONS ====
  declarations: "Declarations",
  declarations_hint: "Please review and confirm the following declarations.",

  accept_data_text:
    "I agree to the collection and processing of my data according to the privacy policy.",
  accept_terms_text: "I have read and agree to the terms and conditions.",
  accept_terms_prefix: "I have read and agree to the",
  terms_and_policy: "Terms and Conditions",
  accept_terms_suffix: ".",

  // ==== BUTTONS / TOAST ====
  save: "Create account",
  saving: "Creating account...",
  go_to_login: "Back to login",

  // ==== VALIDATION / MESSAGES ====
  org_name_required: "Organization name is required.",
  activity_required: "Activity is required.",
  manager_required: "Manager name is required.",
  client_type_required: "Client type is required.",
  user_name_required: "User name is required.",
  email_required: "Email is required.",
  phone_required: "Phone is required.",
  password_required: "Password is required.",
  password_confirm_required: "Password confirmation is required.",
  password_not_match: "Passwords do not match.",
  accept_data_required: "Please accept the data policy.",
  accept_terms_required: "Please accept the terms and conditions.",
  please_check_required: "Please check the required fields.",
  register_success: "Registration completed successfully.",
  consultant_dashboard: {
    // ===== Consultant Dashboard (NEW) =====
    summary_title: "Consultant Dashboard Summary",
    updating: "Updating...",
    year: "Year: {year}",

    sections_consultations: "Consultations",
    sections_payments_revenue: "Payments & Revenue",

    // Consultations
    consultations_total: "Total consultations",
    consultations_status_new: "New",
    consultations_status_accepted: "Accepted",
    consultations_status_under_study: "Under study",
    consultations_status_finished: "Finished",
    consultations_methods_sessions_chats: "Sessions / Chats",

    // Payments
    payments_paid: "Paid",
    payments_unpaid: "Unpaid",
    payments_under_review: "Under review",
    payments_rejected: "Rejected",
    payments_failed: "Failed",
    payments_cancelled: "Cancelled",

    // Revenue
    revenue_paid_total: "Paid total",
    revenue_unpaid_total: "Unpaid total",
    revenue_under_review_total: "Under review total",

  }
  ,// ===== Dashboard – Consultations Chart =====
  dashboard_consultations_overview_title: "Consultations Overview",
  dashboard_consultations_overview_subtitle: "Monthly consultations distribution",

  dashboard_consultations_series_live_chat: "Live Chat",
  dashboard_consultations_series_sessions: "Sessions",
  dashboard_consultations_series_finished: "Finished",

  dashboard_consultations_tooltip_count: "{count} consultations",

  dashboard_year: "Year: {year}",
  common_updating: "Updating...",

  // ===== Months =====
  month_jan: "Jan",
  month_feb: "Feb",
  month_mar: "Mar",
  month_apr: "Apr",
  month_may: "May",
  month_jun: "Jun",
  month_jul: "Jul",
  month_aug: "Aug",
  month_sep: "Sep",
  month_oct: "Oct",
  month_nov: "Nov",
  month_dec: "Dec",
  consultant_dashboard: {

    summary_title: "Performance Summary",
    year: "Year {year}",

    sections: {
      consultations: "Consultations",
      payments_revenue: "Payments & Revenue",
      expenses: "Expenses"

    },
    expenses: {
      unpaid_total: "Unpaid expenses",
      paid_total: "Paid expenses",
      subtitle: "Your paid and due expenses this year",
    },
    consultations: {
      subtitle: "Consultation status and delivery method statistics",
      total: "Total Consultations",
      money: {
        card_title_revenue: "Revenue",
        card_desc_revenue: "Money received & pending (consultant)",
        card_title_expenses: "Expenses",
        card_desc_expenses: "Paid & due amounts ",

        paid_after_tax: "Paid (after tax)",
        unpaid_before_tax: "Unpaid (before tax)",

        paid_expenses: "Paid expenses",
        unpaid_expenses: "Unpaid expenses",

        pill_received: "Received",
        pill_pending: "Pending",
        pill_paid: "Paid",
        pill_due: "Due",

        note_tax: "Note: Paid is shown after adding VAT (15%), while unpaid is shown after VAT.",
      },
      status: {
        new: "New",
        accepted: "Accepted",
        under_study: "Under Study",
        finished: "Finished",
      },
      methods: {
        sessions_chats: "Sessions / Chat",
      },
    },

    revenue: {
      subtitle: "Revenue summary by payment status",
      paid_total: "Total Paid",
      unpaid_total: "Total Unpaid",
    },

    money: {
      card_title_revenue: "Revenue",
      card_desc_revenue: "Money received & pending (consultant)",
      card_title_expenses: "Expenses",
      card_desc_expenses: "Paid & due amounts ",
      paid_after_tax: "Paid (after tax)",
      unpaid_before_tax: "Unpaid (before tax)",
      unpaid_after_tax: "Unpaid (after tax)",
      paid_expenses: "Paid expenses",
      unpaid_expenses: "Unpaid expenses",
      pill_received: "Received",
      pill_pending: "Pending",
      pill_paid: "Paid",
      pill_due: "Due",
      note_tax:
        "Note: Paid is shown after adding VAT (15%), while unpaid is shown before VAT.",
    },


  },

  common: {
    updating: "Updating...",
    updated: "Updated",
    paid: "Paid",
    unpaid: "Unpaid",
  },
  legal: {
    last_updated: "Last updated: {date}",
    read_time: "Reading time: {min} min",

    privacy: {
      badge: "Privacy",
      title: "Privacy Policy",
      subtitle:
        "This policy explains how we collect, use, and protect your information when you use Smart Consulting services.",

      sections: {
        intro: {
          title: "Overview",
          body:
            "We respect your privacy and commit to protecting your personal data with clear controls and responsible processing.",
        },

        data_we_collect: {
          title: "Data we collect",
          b1: "Account details (name, email/phone, role).",
          b2: "Consultation details and related communications.",
          b3: "Payment and invoice information (where applicable).",
          b4: "Technical data (device, logs, cookies) to improve service quality.",
        },

        how_we_use: {
          title: "How we use your data",
          b1: "To provide and manage consultations and support.",
          b2: "To process payments and issue invoices when needed.",
          b3: "To improve platform performance and user experience.",
          b4: "To comply with legal and regulatory requirements.",
        },

        sharing: {
          title: "Sharing and disclosure",
          b1: "We do not sell your data to third parties.",
          b2: "We may share with service providers (hosting/payment) only as needed to deliver the service.",
          b3: "We may disclose when required by law or to protect rights and safety.",
        },

        cookies: {
          title: "Cookies",
          body:
            "We use cookies and similar technologies to remember preferences, secure sessions, and understand usage patterns.",
        },

        rights: {
          title: "Your rights",
          b1: "Request access to your personal data.",
          b2: "Request correction or update of your data.",
          b3: "Request deletion where legally applicable.",
          b4: "Withdraw consent where processing is based on consent.",
        },

        retention: {
          title: "Retention",
          body:
            "We keep data only for the period necessary to provide the service and meet legal obligations, then securely delete or anonymize it.",
        },

        contact: {
          title: "Contact",
          body:
            "For privacy questions or requests, contact us via the support channels available on the website.",
        },
      },
    },

    terms: {
      badge: "Terms",
      title: "Terms & Conditions",
      subtitle:
        "These terms govern your use of Smart Consulting platform and services. By using the service you agree to these terms.",

      sections: {
        acceptance: {
          title: "Acceptance of terms",
          body:
            "By creating an account or using the platform, you agree to comply with these terms and applicable policies.",
        },

        accounts: {
          title: "Accounts and responsibilities",
          b1: "You are responsible for keeping your login credentials secure.",
          b2: "You must provide accurate information and keep it up to date.",
          b3: "Misuse or fraudulent activity may result in account suspension.",
        },

        payments: {
          title: "Payments",
          b1: "Fees and payment terms may vary by service type.",
          b2: "Invoices and payment statuses are shown in your dashboard.",
          b3: "Taxes may apply depending on the service and jurisdiction.",
          b4: "Refund and dispute handling follows the platform policy and applicable law.",
        },

        cancellation: {
          title: "Cancellation",
          body:
            "You may cancel certain services subject to the cancellation rules displayed at the time of purchase or booking.",
        },

        liability: {
          title: "Limitation of liability",
          body:
            "We provide the service as-is and are not liable for indirect or consequential damages to the extent permitted by law.",
        },

        governing_law: {
          title: "Governing law",
          body:
            "These terms are governed by applicable local laws and regulations where the service is offered.",
        },

        changes: {
          title: "Changes to terms",
          body:
            "We may update these terms from time to time. Continued use of the service indicates acceptance of the updated terms.",
        },

        contact: {
          title: "Contact",
          body:
            "For questions about these terms, please contact us through the support channels on the website.",
        },
      },
    },

    consent: {
      terms: "I have read and agree to the Terms & Conditions.",
      privacy: "I agree to the collection and processing of my data in accordance with the Privacy Policy.",
    },
  },

  // ... existing keys
  privacy_intro_1: "At ",
  privacy_brand: "Smart Consulting Platform",
  privacy_intro_2:
    ", we respect your privacy and are committed to protecting your personal data in accordance with applicable laws. By using our services, you agree to the terms of this policy.",

  privacy_s1_title: "1. Information We Collect",
  privacy_s1_item1_label: "Personal information:",
  privacy_s1_item1_text:
    " such as name, phone number, email, address, and banking details.",

  privacy_s2_title: "2. How We Use Information",
  privacy_s2_item1: "To provide services and improve your experience.",
  privacy_s2_item2: "To process requests.",
  privacy_s2_item3: "To contact you about requests, updates, or offers.",
  privacy_s2_item4: "To analyze data and improve the platform and its performance.",

  privacy_s3_title: "3. Sharing Information",
  privacy_s3_item1: "We do not sell or rent your personal data to any third party.",
  privacy_s3_item2:
    "We may disclose your data if required by law or to protect our legal rights.",

  privacy_s4_title: "4. Cookies",
  privacy_s4_text:
    "We use cookies to improve browsing experience, facilitate login, and anonymously track usage for performance analysis.",

  privacy_s5_title: "5. Data Protection",
  privacy_s5_text:
    "We use appropriate technical and organizational measures to protect your data from unauthorized access or use.",

  privacy_s6_title: "6. Your Rights",
  privacy_s6_item1:
    "You can request access to, correction of, or deletion of your personal data when needed.",

  privacy_s7_title: "7. External Links",
  privacy_s7_text:
    "Our platform may contain links to external websites. We are not responsible for their privacy policies.",

  privacy_s8_title: "8. Policy Updates",
  privacy_s8_text:
    "We may update this policy from time to time. Updates will be published on this page along with the updated date.",

  privacy_s9_title: "9. Contact Us",
  privacy_s9_text:
    "For any inquiry or request regarding the Privacy Policy, you can contact us via:",

  privacy_email_label: "Email:",
  privacy_phone_label: "Phone:",
  privacy_updated_label: "Last updated",
  privacy_updated_date: "1 / 2 / 2026",

  sidebar_group_tickets: "Tickets",
  sidebar_item_my_tickets: "My tickets",
  sidebar_item_create_ticket: "Create ticket",

  ticket_my_title: "My tickets",
  ticket_my_subtitle: "Track and manage your support tickets",
  ticket_create_title: "Create ticket",
  ticket_create_subtitle: "Describe your issue and we will follow up",
  ticket_create_form_section: "Ticket details",
  ticket_create_tips_title: "Before you submit",
  ticket_create_tip_subject: "Use a clear subject so we can route your ticket faster.",
  ticket_create_tip_details: "Include steps, error messages, and what you expected to happen.",
  ticket_create_tip_files: "Screenshots or documents help us resolve issues quicker.",
  ticket_detail_title: "Ticket details",
  ticket_search_placeholder: "Number or subject…",
  ticket_search_hint: "Search by ticket number or subject.",
  ticket_filter_all: "All",
  ticket_filter_new: "New",
  ticket_filter_label: "Filter by status",
  ticket_filter_clear: "Clear filter",
  ticket_filter_clear_all: "Clear all",
  ticket_filter_status: "Status",
  ticket_filter_search: "Search",
  ticket_filter_active_hint: "Filtered results",
  ticket_results_count: "Showing",
  notifications_title: "Notifications",
  notifications_subtitle: "Updates on your tickets and consultations",
  notifications_empty: "You're all caught up",
  notifications_mark_all_read: "Mark all as read",
  notifications_view_all: "View all notifications",
  notifications_loading: "Loading…",
  notifications_tab_all: "All",
  notifications_tab_tickets: "Tickets",
  notifications_tab_consultations: "Consultations",
  notifications_unread_label: "unread",
  notifications_all_read: "All caught up",
  notifications_empty_hint: "We'll notify you when something needs your attention.",
  notifications_error: "Couldn't load notifications",
  notifications_retry: "Try again",
  notifications_total_label: "Total",
  notifications_refresh: "Refresh",
  notifications_filter_label: "Filter notifications",
  notifications_tab_negotiations: "Negotiations",
  notifications_page_prev: "Previous",
  notifications_page_next: "Next",
  ticket_table_number: "Ticket #",
  ticket_table_type: "Type",
  ticket_table_subject: "Subject",
  ticket_table_status: "Status",
  ticket_table_party: "Party",
  ticket_table_updated: "Last update",
  ticket_table_actions: "Actions",
  ticket_table_empty: "No tickets yet.",
  ticket_table_empty_filtered: "No tickets match your filters.",
  ticket_table_empty_hint: "Create a ticket when you need help from our team.",
  ticket_load_failed: "Failed to load tickets.",
  ticket_create_success: "Ticket created successfully.",
  ticket_create_failed: "Failed to create ticket.",
  ticket_subject: "Subject",
  ticket_subject_placeholder: "Brief summary of the issue",
  ticket_description: "Description",
  ticket_description_placeholder: "Describe the problem in detail",
  ticket_priority: "Priority",
  ticket_category: "Category",
  ticket_category_none: "No category",
  ticket_attachments: "Attachments",
  ticket_attachments_hint: "Up to 5 files, 10MB each (images, PDF, Office)",
  ticket_sla_hint: "Expected response within",
  ticket_hours: "hours",
  ticket_submit_create: "Submit ticket",
  ticket_copy_number: "Copy ticket number",
  ticket_status_new: "New",
  ticket_status_unknown: "Unknown",
  ticket_timeline: "Activity log",
  ticket_timeline_empty: "No activity yet.",
  ticket_load_more: "Load more",
  ticket_comments: "Comments",
  ticket_comments_empty: "No comments yet.",
  ticket_comments_empty_hint: "Add your comment or files in the form below",
  ticket_comment_placeholder: "Write your message…",
  ticket_comment_submit: "Send comment",
  ticket_comment_success: "Comment added.",
  ticket_comment_failed: "Failed to add comment.",
  ticket_reopen: "Reopen",
  ticket_escalate: "Escalate",
  ticket_close: "Close ticket",
  ticket_reopen_hint: "Problem returned — reopen to customer service",
  ticket_escalate_hint: "Unhappy with resolution — escalate to management",
  ticket_close_hint: "Resolution accepted — close the ticket for good",
  ticket_close_confirm:
    "Confirming means you accept the resolution and the ticket will be closed. Continue?",
  ticket_reopen_success: "Ticket reopened.",
  ticket_escalate_success: "Ticket escalated.",
  ticket_close_success: "Ticket closed.",
  ticket_action_failed: "Action failed.",
  ticket_note_optional: "Note (optional)",
  ticket_requester: "Requester",
  ticket_no_attachments: "No attachments",
  ticket_view: "View",
  ticket_back_list: "Back to tickets",
  ticket_not_found: "Ticket not found.",
  ticket_overdue: "Overdue",
  ticket_create_cta: "New ticket",
  ticket_tab_discussion: "Discussion",
  ticket_tab_activity: "Activity log",
  ticket_created_at: "Created",
  ticket_dropzone_title: "Drag files here or click to browse",
  ticket_comment_yours: "Your comments",
  ticket_comment_others: "Team & others",
  ticket_comment_creator: "Ticket creator",
  ticket_comment_handler: "Ticket handler",
  ticket_support_team: "Support team",
  ticket_actor_system: "System",
  ticket_detail_subtitle: "Track ticket information and responses",
  ticket_summary: "Ticket summary",
  ticket_assigned_to: "Assigned to",
  ticket_unassigned: "Unassigned",
  ticket_comments_closed: "Comments are closed",
  ticket_comment_you: "You",
  ticket_comment_participants: "Participants",
  ticket_comments_sort_oldest: "Oldest first",
  ticket_comments_sort_newest: "Newest first",
  ticket_comment_attachments_only: "Attachments only",
  ticket_timeline_top: "Top",
  ticket_show_more: "Show more",
  ticket_show_less: "Show less",
  ticket_today: "Today",
  ticket_yesterday: "Yesterday",
  ticket_event_latest: "Latest",
  ticket_event_comment: "New comment",
  ticket_event_create: "Ticket created",
  ticket_event_reopen: "Reopened",
  ticket_event_escalate: "Escalated",
  ticket_event_resolve: "Resolved",
  ticket_event_assign: "Assigned",
  ticket_event_transfer: "Transferred",
  ticket_event_close: "Closed",
  ticket_event_note: "Note",
  ticket_event_status: "Status changed",
};
